/** @jsx h */
import { h, hydrate } from 'preact';
import DraftOrders from '../components/DraftOrders';

function initPreactDraftOrders() {
  const mountPoint = document.getElementById('preact-draft-orders');

  if (!mountPoint) return;

  hydrate(<DraftOrders />, mountPoint);
}

document.addEventListener('DOMContentLoaded', initPreactDraftOrders);
